import { DownOutlined } from "@ant-design/icons";

const CustomSelectCellRenderer = (props: any) => {
  const { value, api, node, column } = props;

  const handleClick = () => {
    api.startEditingCell({
      rowIndex: node.rowIndex,
      colKey: column.getColId(),
    });
  };

  return (
    <div
      className={`flex items-center justify-between w-full pl-2 cursor-pointer mt-1`}
      onClick={handleClick}
    >
      <span className="text-xs text-gray-800">
        {value}
      </span>
      <DownOutlined className="text-gray-400 text-xs ml-1" />
    </div>
  );
};

export default CustomSelectCellRenderer;